(() => {
  'use strict';


  const root =
    document.querySelector(
      '[data-pnauth-profile-page]'
    );

  if (!root) return;


  const loading =
    root.querySelector(
      '[data-pnprofile-loading]'
    );

  const content =
    root.querySelector(
      '[data-pnprofile-content]'
    );

  const form =
    root.querySelector(
      '[data-pnprofile-form]'
    );

  const message =
    root.querySelector(
      '[data-pnprofile-message]'
    );

  const avatarInput =
    root.querySelector(
      '[data-pnprofile-avatar-input]'
    );

  const avatarRemove =
    root.querySelector(
      '[data-pnprofile-avatar-remove]'
    );

  const resumeInput =
    root.querySelector(
      '[data-pnprofile-resume-input]'
    );

  const resumeView =
    root.querySelector(
      '[data-pnprofile-resume-view]'
    );

  const resumeRemove =
    root.querySelector(
      '[data-pnprofile-resume-remove]'
    );

  const resumeName =
    root.querySelector(
      '[data-pnprofile-resume-name]'
    );

  const projectForm =
    root.querySelector(
      '[data-pnproject-form]'
    );

  const projectSave =
    root.querySelector(
      '[data-pnproject-save]'
    );

  const projectCancel =
    root.querySelector(
      '[data-pnproject-cancel]'
    );

  const projectsWrap =
    root.querySelector(
      '[data-pnprojects]'
    );


  let profile = null;
  let projects = [];
  let editingProjectId = null;


  function initials() {

    const source =
      profile?.full_name ||
      profile?.email ||
      'PN';


    return source
      .split(/\s+/)
      .filter(Boolean)
      .slice(0,2)
      .map(part =>
        part.charAt(0)
          .toUpperCase()
      )
      .join('');

  }


  function setText(
    selector,
    value
  ) {

    root
      .querySelectorAll(selector)
      .forEach(
        element => {
          element.textContent =
            value || '';
        }
      );

  }


  function renderAvatarElement(
    element,
    avatarURL,
    fallback
  ) {

    if (!element) return;


    if (avatarURL) {

      element.textContent = '';

      element.style.backgroundImage =
        `url("${avatarURL}")`;

      element.style.backgroundSize =
        'cover';

      element.style.backgroundPosition =
        'center';

    }
    else {

      element.style.backgroundImage =
        '';

      element.textContent =
        fallback;

    }

  }


  function renderAvatar() {

    const fallback =
      initials();


    root
      .querySelectorAll(
        '[data-pnprofile-avatar]'
      )
      .forEach(
        element =>
          renderAvatarElement(
            element,
            profile?.avatar_url,
            fallback
          )
      );


    document
      .querySelectorAll(
        '[data-pnauth-avatar], [data-pndash-avatar]'
      )
      .forEach(
        element =>
          renderAvatarElement(
            element,
            profile?.avatar_url,
            fallback
          )
      );


    if (avatarRemove) {
      avatarRemove.hidden =
        !profile?.avatar_url || profile?.role === 'mentor';
    }

  }


  function roleLabel() {

    const role =
      profile?.role ||
      'student';


    return (
      role.charAt(0).toUpperCase()
      +
      role.slice(1)
    );

  }


  function renderProfile() {

    setText(
      '[data-pnprofile-name]',
      profile?.full_name ||
      'PeerNest User'
    );

    setText(
      '[data-pnprofile-email]',
      profile?.email ||
      ''
    );

    setText(
      '[data-pnprofile-role]',
      roleLabel()
    );

    setText(
      '[data-pnprofile-status]',
      profile?.account_status ||
      ''
    );


    const created =
      profile?.created_at
        ? new Date(
            profile.created_at
          ).toLocaleDateString(
            undefined,
            {
              year:'numeric',
              month:'short',
              day:'numeric'
            }
          )
        : '';


    setText(
      '[data-pnprofile-created]',
      created
    );


    if (form) {

      const set =
        (name, value) => {

          const input =
            form.elements[name];

          if (input) {
            input.value =
              value ?? '';
          }

        };


      set(
        'full_name',
        profile?.full_name
      );

      set(
        'phone',
        profile?.phone
      );

      set(
        'bio',
        profile?.bio
      );

      set(
        'institution',
        profile?.institution
      );

      set(
        'program',
        profile?.program
      );

      set(
        'graduation_year',
        profile?.graduation_year
      );

      set(
        'skills',
        Array.isArray(
          profile?.skills
        )
          ? profile.skills.join(', ')
          : ''
      );

      set(
        'linkedin_url',
        profile?.linkedin_url
      );

      set(
        'github_url',
        profile?.github_url
      );

      set(
        'portfolio_url',
        profile?.portfolio_url
      );

    }


    if (resumeName) {

      resumeName.textContent =
        profile?.resume_path
          ? 'Resume uploaded'
          : 'No resume uploaded';

    }


    if (resumeView) {
      resumeView.hidden =
        !profile?.resume_path;
    }


    if (resumeRemove) {
      resumeRemove.hidden =
        !profile?.resume_path;
    }


    renderAvatar();

  }


  function showMessage(
    text,
    type = 'success'
  ) {

    if (!message) return;


    message.hidden =
      false;

    message.textContent =
      text;

    message.dataset.type =
      type;

  }


  function validURL(
    value
  ) {

    if (!value) return true;


    try {

      const url =
        new URL(value);

      return [
        'http:',
        'https:'
      ].includes(
        url.protocol
      );

    }
    catch {
      return false;
    }

  }


  function projectCard(
    project
  ) {

    const card =
      document.createElement(
        'article'
      );

    card.className =
      'pnp__project-card';


    const title =
      document.createElement(
        'h4'
      );

    title.textContent =
      project.title;


    const description =
      document.createElement(
        'p'
      );

    description.textContent =
      project.description ||
      'No description added.';


    const tags =
      document.createElement(
        'div'
      );

    tags.className =
      'pnp__project-tags';


    (
      project.technologies ||
      []
    ).forEach(
      technology => {

        const tag =
          document.createElement(
            'span'
          );

        tag.textContent =
          technology;

        tags.appendChild(
          tag
        );

      }
    );


    const actions =
      document.createElement(
        'div'
      );

    actions.className =
      'pnp__project-card-actions';


    if (
      validURL(
        project.project_url
      ) &&
      project.project_url
    ) {

      const link =
        document.createElement(
          'a'
        );

      link.href =
        project.project_url;

      link.target =
        '_blank';

      link.rel =
        'noopener';

      link.textContent =
        'View project';

      actions.appendChild(
        link
      );

    }


    const edit =
      document.createElement(
        'button'
      );

    edit.type =
      'button';

    edit.textContent =
      'Edit';

    edit.addEventListener(
      'click',
      () => {

        editingProjectId =
          project.id;


        projectForm.elements.title.value =
          project.title || '';

        projectForm.elements.description.value =
          project.description || '';

        projectForm.elements.project_url.value =
          project.project_url || '';

        projectForm.elements.github_url.value =
          project.github_url || '';

        projectForm.elements.technologies.value =
          (
            project.technologies ||
            []
          ).join(', ');


        projectSave.textContent =
          'Save project';

        projectCancel.hidden =
          false;


        projectForm.scrollIntoView({
          behavior:'smooth',
          block:'center'
        });

      }
    );


    const remove =
      document.createElement(
        'button'
      );

    remove.type =
      'button';

    remove.textContent =
      'Delete';

    remove.addEventListener(
      'click',
      async () => {

        if (
          !confirm(
            `Delete "${project.title}"?`
          )
        ) {
          return;
        }


        try {

          await window.PeerNestDB
            .deleteMyProject(
              project.id
            );


          await loadProjects();

        }
        catch (error) {

          console.error(
            error
          );

          showMessage(
            'Project could not be deleted.',
            'error'
          );

        }

      }
    );


    actions.append(
      edit,
      remove
    );

    const featureButton = window.PeerNestMentorAccount?.makeFeatureButton?.(project, loadProjects);
    if (featureButton) actions.appendChild(featureButton);

    card.append(
      title,
      description,
      tags,
      actions
    );


    return card;

  }


  function renderProjects() {

    if (!projectsWrap) return;


    projectsWrap.innerHTML =
      '';


    if (!projects.length) {

      const empty =
        document.createElement(
          'div'
        );

      empty.className =
        'pnp__project-empty';

      empty.textContent =
        'No projects added yet.';

      projectsWrap.appendChild(
        empty
      );

      return;

    }


    projects.forEach(
      project => {

        projectsWrap.appendChild(
          projectCard(
            project
          )
        );

      }
    );

  }


  async function loadProjects() {

    projects =
      await window.PeerNestDB
        .getMyProjects();

    try { await window.PeerNestMentorAccount?.refreshFeatured?.(); }
    catch (error) { console.warn('[PeerNest] Featured projects:', error); }

    renderProjects();

  }


  async function load() {

    profile =
      await window.PeerNestDB
        .getMyProfile();


    if (!profile) {
      return;
    }


    renderProfile();

    // PN_MENTOR_MY_PROFILE_CONSOLIDATION_V1: mentor additions only.
    try {
      await window.PeerNestMentorAccount?.initialize?.(profile);
    } catch (error) {
      console.warn('[PeerNest] Mentor additions unavailable:', error);
    }

    await loadProjects();


    if (loading) {
      loading.hidden =
        true;
    }


    if (content) {
      content.hidden =
        false;
    }

  }


  form?.addEventListener(
    'submit',
    async event => {

      event.preventDefault();


      const data =
        new FormData(form);


      const links = [
        'linkedin_url',
        'github_url',
        'portfolio_url'
      ];


      for (
        const field of links
      ) {

        const value =
          String(
            data.get(field) ||
            ''
          ).trim();


        if (
          !validURL(value)
        ) {

          showMessage(
            'Use a valid http/https link.',
            'error'
          );

          return;

        }

      }


      if (window.PeerNestMentorAccount?.validateAccountSave?.() === false) {
        showMessage('Please complete the mentor-specific profile requirements below.', 'error');
        return;
      }

      const save =
        root.querySelector(
          '[data-pnprofile-save]'
        );


      save.disabled =
        true;

      save.textContent =
        'Saving…';


      let accountWasSaved = false;
      try {

        profile =
          await window.PeerNestDB
            .updateMyProfileDetails({
              full_name:
                data.get('full_name'),

              phone:
                data.get('phone'),

              bio:
                data.get('bio'),

              institution:
                data.get('institution'),

              program:
                data.get('program'),

              graduation_year:
                data.get(
                  'graduation_year'
                ),

              skills:
                String(
                  data.get('skills') ||
                  ''
                )
                  .split(',')
                  .map(
                    item =>
                      item.trim()
                  )
                  .filter(Boolean),

              linkedin_url:
                data.get(
                  'linkedin_url'
                ),

              github_url:
                data.get(
                  'github_url'
                ),

              portfolio_url:
                data.get(
                  'portfolio_url'
                )
            });


        accountWasSaved = true;
        await window.PeerNestMentorAccount?.syncFromAccountSave?.(profile);
        renderProfile();

        showMessage(profile?.role === 'mentor'
          ? (window.PeerNestMentorAccount?.isReady?.()
              ? 'My Profile and public mentor details saved.'
              : 'Account saved. Public mentor sync is not ready; check the mentor migration.')
          : 'Profile saved.');

      }
      catch (error) {

        console.error(
          error
        );


        showMessage(
          accountWasSaved
            ? `Your account saved, but public mentor details did not: ${error.message || 'Please retry.'}`
            : 'Profile could not be saved.',
          'error'
        );

      }
      finally {

        save.disabled =
          false;

        save.textContent =
          'Save profile';

      }

    }
  );


  avatarInput?.addEventListener(
    'change',
    async () => {

      const file =
        avatarInput.files?.[0];


      if (!file) return;


      try {

        const url =
          await window.PeerNestDB
            .uploadMyAvatar(
              file
            );


        profile.avatar_url =
          url;


        renderAvatar();

        // A new mentor photo updates both storage locations and the public profile.
        try { await window.PeerNestMentorAccount?.syncAvatar?.(file, url); }
        catch (error) { console.error('[PeerNest] Mentor photo sync:', error); throw new Error(`Account photo saved, but the mentor photo did not sync: ${error.message || error}`); }

        showMessage(profile?.role === 'mentor'
          ? (window.PeerNestMentorAccount?.isReady?.()
              ? 'Account and mentor photos updated.'
              : 'Account photo updated. Public mentor photo was not synchronized.')
          : 'Profile photo updated.');

      }
      catch (error) {

        console.error(
          error
        );


        showMessage(
          error.message ||
          'Photo upload failed.',
          'error'
        );

      }
      finally {

        avatarInput.value =
          '';

      }

    }
  );


  avatarRemove?.addEventListener(
    'click',
    async () => {

      if (profile?.role === 'mentor') {
        showMessage('Mentor photos must be replaced, not removed. Use Change photo.', 'error');
        return;
      }

      try {

        await window.PeerNestDB
          .removeMyAvatar();


        profile.avatar_url =
          null;


        renderAvatar();


        showMessage(
          'Profile photo removed.'
        );

      }
      catch (error) {

        console.error(
          error
        );


        showMessage(
          'Photo could not be removed.',
          'error'
        );

      }

    }
  );


  resumeInput?.addEventListener(
    'change',
    async () => {

      const file =
        resumeInput.files?.[0];


      if (!file) return;


      try {

        const path =
          await window.PeerNestDB
            .uploadMyResume(
              file
            );


        profile.resume_path =
          path;


        renderProfile();


        showMessage(
          'Resume uploaded.'
        );

      }
      catch (error) {

        console.error(
          error
        );


        showMessage(
          error.message ||
          'Resume upload failed.',
          'error'
        );

      }
      finally {

        resumeInput.value =
          '';

      }

    }
  );


  resumeView?.addEventListener(
    'click',
    async () => {

      const tab =
        window.open(
          '',
          '_blank'
        );


      try {

        const url =
          await window.PeerNestDB
            .getMyResumeURL();


        if (!url) {
          throw new Error(
            'Resume unavailable.'
          );
        }


        if (tab) {
          tab.location.href =
            url;
        }

      }
      catch (error) {

        tab?.close();


        showMessage(
          'Resume could not be opened.',
          'error'
        );

      }

    }
  );


  resumeRemove?.addEventListener(
    'click',
    async () => {

      try {

        await window.PeerNestDB
          .removeMyResume();


        profile.resume_path =
          null;


        renderProfile();


        showMessage(
          'Resume removed.'
        );

      }
      catch (error) {

        console.error(
          error
        );


        showMessage(
          'Resume could not be removed.',
          'error'
        );

      }

    }
  );


  projectForm?.addEventListener(
    'submit',
    async event => {

      event.preventDefault();


      const data =
        new FormData(
          projectForm
        );


      const payload = {
        title:
          data.get('title'),

        description:
          data.get(
            'description'
          ),

        project_url:
          data.get(
            'project_url'
          ),

        github_url:
          data.get(
            'github_url'
          ),

        technologies:
          String(
            data.get(
              'technologies'
            ) ||
            ''
          )
            .split(',')
            .map(
              item =>
                item.trim()
            )
            .filter(Boolean)
      };


      if (
        !payload.title
          .trim()
      ) {
        return;
      }


      if (
        !validURL(
          payload.project_url
        ) ||
        !validURL(
          payload.github_url
        )
      ) {

        showMessage(
          'Use valid project links.',
          'error'
        );

        return;

      }


      try {

        if (
          editingProjectId
        ) {

          await window.PeerNestDB
            .updateMyProject(
              editingProjectId,
              payload
            );

        }
        else {

          await window.PeerNestDB
            .createMyProject(
              payload
            );

        }


        editingProjectId =
          null;

        projectForm.reset();

        projectSave.textContent =
          'Add project';

        projectCancel.hidden =
          true;


        await loadProjects();

      }
      catch (error) {

        console.error(
          error
        );


        showMessage(
          'Project could not be saved.',
          'error'
        );

      }

    }
  );


  window.addEventListener('peernest:profile-projects-changed', () => {
    loadProjects().catch(error => console.error('[PeerNest] Projects refresh:', error));
  });

  projectCancel?.addEventListener(
    'click',
    () => {

      editingProjectId =
        null;

      projectForm.reset();

      projectSave.textContent =
        'Add project';

      projectCancel.hidden =
        true;

    }
  );


  function waitForDB(
    attempt = 0
  ) {

    if (
      window.PeerNestDB
        ?.updateMyProfileDetails
    ) {

      load().catch(
        error => {

          console.error(
            '[PeerNest Profile]',
            error
          );

        }
      );

      return;

    }


    if (
      attempt < 60
    ) {

      setTimeout(
        () =>
          waitForDB(
            attempt + 1
          ),
        100
      );

    }

  }


  waitForDB();

})();
